import React from 'react';
import { popupStore } from '@pascal/pascal-core/shared/core/store';
import { PopUps } from '@pascal/pascal-core/table-line/t_types/enums/PopupTypes';
import { CARDS, CARDS_TYPES_DATA, UNKNOWN_CARD_TYPE } from '../../../enums/cardTypes';

function ResultRow({ result, setSelectedResultInfo, t }) {
  return (
    <div key={result.hash || result.salt} className='results-fairness-check-row'>
      <div className='results-fairness-check-column'>
        {result.roundId ? (
          <span className='results-fairness-check-id'>{result.roundId}</span>
        ) : (
          '***'
        )}
      </div>
      <div className='results-fairness-check-column'>
        {result.card === UNKNOWN_CARD_TYPE || result.card === CARDS.CUTTING_CARD ? (
          <span
            className={`results-fairness-check-text ${
              result.card === CARDS.CUTTING_CARD ? 'red' : ''
            }`}
          >
            {result.card === CARDS.CUTTING_CARD ? t('CUTTING_CARD') : t('UPCOMING')}
          </span>
        ) : (
          <div className={`results-fairness-check-cards ${CARDS_TYPES_DATA[result.card]?.color}`}>
            <span>{CARDS_TYPES_DATA[result.card]?.name}</span>
            <i className={`icon-${CARDS_TYPES_DATA[result.card]?.icon}`} />
          </div>
        )}
      </div>
      <div
        className='results-fairness-check-column check'
        onClick={() => {
          setSelectedResultInfo({
            ...result,
            resultKey: result.key || '',
            resultHash: result.hash || '',
            resultSalt: result.salt || '',
          });
          popupStore.open({ name: PopUps.CheckHash });
        }}
      >
        <i className='icon-security results-fairness-check-icon' />
      </div>
    </div>
  );
}

export default ResultRow;
